import { useEffect } from "react";

// Dynamically manage document <head> for a page, restoring previous values on unmount.
export function useSeo({ title, description, canonical, image, url, jsonLd, type = "article" }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const created = [];
    const changed = [];

    const upsertMeta = (attr, key, content) => {
      if (content == null) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (el) {
        changed.push([el, el.getAttribute("content")]);
      } else {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        created.push(el);
      }
      el.setAttribute("content", content);
    };

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    // Canonical
    let canonicalEl = document.head.querySelector('link[rel="canonical"]');
    let prevCanonical = null;
    let createdCanonical = false;
    if (canonical) {
      if (canonicalEl) {
        prevCanonical = canonicalEl.getAttribute("href");
      } else {
        canonicalEl = document.createElement("link");
        canonicalEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalEl);
        createdCanonical = true;
      }
      canonicalEl.setAttribute("href", canonical);
    }

    // JSON-LD structured data
    let ldEl = null;
    if (jsonLd) {
      ldEl = document.createElement("script");
      ldEl.type = "application/ld+json";
      ldEl.id = "page-jsonld";
      ldEl.text = JSON.stringify(jsonLd);
      document.head.appendChild(ldEl);
    }

    return () => {
      document.title = prevTitle;
      created.forEach((el) => el.remove());
      changed.forEach(([el, val]) => { if (val == null) el.removeAttribute("content"); else el.setAttribute("content", val); });
      if (canonicalEl) {
        if (createdCanonical) canonicalEl.remove();
        else if (prevCanonical != null) canonicalEl.setAttribute("href", prevCanonical);
      }
      if (ldEl) ldEl.remove();
    };
  }, [title, description, canonical, image, url, type, jsonLd]);
}
